
<section [hidden]="!label && !description && !secondaryText" [class]="['status', props.statusType ?? 'neutral']">
    @if ( !!props.icon || !!label ) {
    <div [class]="['display-flex','flex-full']">
        <mat-icon class='mutara-icon'>{{props.icon}}</mat-icon>
        @if ( !!label ) {
        <mat-label>
            <h2 class="mat-headline-3">{{label}}</h2>
        </mat-label>
        }
    </div>
    }
    @if ( !!description ) {
    <markdown [disableSanitizer]="true">{{description}}</markdown>
    }
    @if ( !!description && !!secondaryText ) {
    <br />
    }
    @if ( !!secondaryText ) {
    <markdown class="centered" [disableSanitizer]="true">{{secondaryText}}</markdown>
    }
</section>